import { type SimulationState, setHeaders } from 'features/simulations/utils';
import { useEffect, useState } from 'react';

import type { Position } from 'API';

const domain = import.meta.env.VITE_SIMULATION_ROUTE;

interface Simulation {
    vin: string;
    state: SimulationState;
    startedAt?: string;
    routeWaypoints: Position[];
}

const useGetSimulations = () => {
    const [simulations, setSimulations] = useState<Simulation[] | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    const fetchSimulations = async () => {
        const url = `${domain}/simulator-adapter-service/api/v2/simulation`;
        setIsLoading(true);

        try {
            const res = await fetch(url, {
                method: 'GET',
                headers: await setHeaders(),
            });

            const payload = (await res.json()) as Simulation[];
            setSimulations(payload);
        } catch (error) {
            console.error(error);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!simulations) {
            fetchSimulations();
        }
    }, [simulations]);

    return {
        scenarios: isError ? [] : simulations,
        isLoading,
        isError,
        refresh: fetchSimulations,
    };
};

export default useGetSimulations;
